import React from "react";
import { Home } from "lucide-react";
import services1 from '../assets/images/ser1img.png';
import services2 from '../assets/images/ser2img.png';
import services3 from '../assets/images/ser3img.png';
 const Services = () =>{
    return(
       <div>
            <section className="home-main-section service-bannar-img">

                <div className="container text-center">
                    <div>
                        {/* <p className="banner-heading">Services </p>
                        <Home className="banner-home-icon" /> <span className="bannner-subhead">/ Services</span> */}
                    </div>
                </div>
         </section>

<section className="service-page-section">
        <div className="container">
          <p className="service-page-title">Our Services</p>
          <div className="services-div"></div>
          <div className="row   services-row">
            {/* Card 1 */}
            <div className="col-12 col-md-6 col-lg-4 mb-4">
              <div className="service-page-card">
                <div className="service-page-icon-box">
                  <img
                    src={services1}
                    alt="Story Sharing"
                    className="service-page-icon"
                  />
                </div>
                <p className="service-page-card-title">Story Sharing</p>
               <p className="service-page-card-text">
     Share your spiritual experiences in Hindi or English.< br/>
      Submit stories in written form or as a voice recording. < br/>
    
        Published on our platform for all visitors to read, listen, and be
        inspired.
    
   </p>
              </div>
            </div>

            {/* Card 2 */}
            <div className="col-12 col-md-6 col-lg-4 mb-4">
              <div className="service-page-card">
                <div className="service-page-icon-box">
                  <img
                    src={services2}
                    alt="Story Printing"
                    className="service-page-icon"
                  />
                </div>
                <p className="service-page-card-title">Story Printing</p>
                <p className="service-page-card-text">
                 Preserve your journey as a beautifully crafted book.<br/>
 Available at an additional cost per copy.<br/>
Bulk printing and distribution supported, so you can gift these divine stories to family,
friends, or your community.<br/>
                </p>
              </div>
            </div>

            {/* Card 3 */}
            <div className="col-12 col-md-6 col-lg-4 mb-4">
              <div className="service-page-card">
                <div className="service-page-icon-box">
                  <img
                    src={services3}
                    alt="Story Printing / Donation"
                    className="service-page-icon"
                  />
                </div>
                <p className="service-page-card-title">Community Contribution</p>
                <p className="service-page-card-text">
             One-time lifetime registration of ₹499.<br/>
 50% of the amount goes towards helping the needy and charitable institutions.<br/>
 The remaining 50% supports platform operations and growth.
                </p>
              </div>
            </div>
          </div>
                <p className="sevices-sec-bottom-tittle">Every story shared at TheOmSaga spreads divine light, strengthens belief, and reminds us
that miracles truly do happen.</p>
        </div>


  
      </section>
       </div>

    )
 }
 export default Services